const tablePageSizes = [10, 15, 25, 35, 50];
export default tablePageSizes;
